(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["focean-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('.fc-colors__item');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (window.Shopify?.theme?.role === 'unpublished') {
    url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    url.searchParams.set('_fd', '0');
    url.searchParams.set('pb', '0');
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(url.href);
}, true);

document.addEventListener('change', (event) => {
  const picker = event.target.closest('high-variant-selects');
  if (!picker) return;
  const scope = picker.closest('product-info') || picker.parentElement;
  const size = picker.querySelector('input[name="Size"]:checked,select[name="options[Size]"]')?.value;
  const adhesive = picker.querySelector('input[name="Adhesive"]:checked,select[name="options[Adhesive]"]')?.value;
  scope.querySelectorAll('.fc-colors__item[data-color-variants]').forEach((link) => {
    const variants = JSON.parse(link.dataset.colorVariants);
    const match = variants.find((variant) => variant.option1 === size && variant.option2 === adhesive);
    if (match) {
      const url = new URL(link.href);
      url.searchParams.set('variant', match.id);
      link.href = url.toString();
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
